import { Component, signal, WritableSignal, inject, output } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../../core/services/admin.service';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-check-terms',
  templateUrl: './check-terms.component.html',
  styleUrls: ['./check-terms.component.scss'],
  imports: [NgxExtendedPdfViewerModule]
})
export class CheckTermsComponent {
  private readonly router = inject(Router);
  private readonly adminService = inject(AdminService);

  readonly isTermsCheckedEvent = output<boolean>();

  readonly isCheck$: WritableSignal<boolean> = signal(false);
  readonly pdfSrc = '/assets/files/terms_of_use.pdf';

  toggleCheck() {
    this.isCheck$.update((value) => !value);
  }

  checkTerms() {
    this.adminService.updateEulaStatus()
      .subscribe(() => {
        this.isTermsCheckedEvent.emit(true);
      });
  }

  logout() {
    this.router.navigateByUrl('/logout');
  }
}
